/**
 * Story 564, settings.page.route: the settings page is chosen by the workspace's
 * address, like the open story and tab (pages/Workspace.tsx). These are the pure
 * rules for that address, kept apart from the page so they can be tested alone.
 */

/** The workspace query parameter that holds the section being shown. */
export const SETTINGS_PARAM = 'settings';

/**
 * The section to show: the one the address names when it is registered,
 * otherwise the first registered section, so a stale or mistyped link shows a
 * real section rather than an empty page.
 */
export function resolveSettingsSection(param: string | null, sections: ReadonlyArray<{ id: string }>): string {
  const named = sections.find((section) => section.id === param);
  return (named ?? sections[0]).id;
}

/** The workspace address with settings open on a section; every other parameter is kept. */
export function withSettingsOpen(prev: URLSearchParams, sectionId: string): URLSearchParams {
  const next = new URLSearchParams(prev);
  next.set(SETTINGS_PARAM, sectionId);
  return next;
}

/** The workspace address with settings closed; every other parameter is kept, so the open story stays open. */
export function withoutSettings(prev: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(prev);
  next.delete(SETTINGS_PARAM);
  return next;
}
